import moment from 'moment';

/**
 * Map date from dto.
 * @param {string} dto Dto.
 * @returns {string | null}
 */
function fromDto(dto) {
  if (dto == null) {
    return null;
  }
  return moment(dto).format('YYYY-MM-DDTHH:mm:ssZ');
}

/**
 * Map date to dto
 * @param {Date | string | undefined} date Date
 * @returns {string}
 */
function toDto(date) {
  if (date == null) {
    return undefined;
  }
  return moment(date).format('YYYY-MM-DD');
}

export const dateMapper = {
  fromDto,
  toDto,
};
